import Sentry from "@similarweb/sentry-logger";
import { ESecondaryItemType } from "@similarweb/ui-components";

import { SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID } from "app/pages/segments/config/const";
import { isHidden } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { applyNavItemPermissions } from "app/pages/workspace/common/workspacesUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { INavItem } from "../../../types";

interface INavSubItem {
    itemType?: ESecondaryItemType;
    title: string;
    name: string;
    state: string;
    options: {
        isUSStatesSupported: boolean;
        isVirtualSupported: boolean;
    };
    supportPredefined?: boolean;
    isBeta?: boolean;
    hidden?: boolean;
}

interface INavGroup {
    title: string;
    name: string;
    subItems: INavSubItem[];
    hidden?: boolean;
}

export const segmentAnalysisNavObj = (): { navList: INavItem[] } => {
    const segmentAnalysisGroup: INavGroup[] = [
        {
            title: "analysis.audience.title",
            name: "segments",
            subItems: [
                {
                    itemType: ESecondaryItemType.Report,
                    title: "segment.analysis.traffic.engagement.title",
                    name: "segmentOverview",
                    state: "digitalsuite_segments-analysis-traffic",
                    options: {
                        isUSStatesSupported: false,
                        isVirtualSupported: false,
                    },
                    supportPredefined: true,
                },
                {
                    itemType: ESecondaryItemType.Report,
                    title: "segment.analysis.geography.title",
                    name: "segmentGeography",
                    state: "digitalsuite_segments-analysis-geography",
                    options: {
                        isUSStatesSupported: false,
                        isVirtualSupported: false,
                    },
                },
            ],
        },
        {
            title: "analysis.acquisition.title",
            name: "segments",
            subItems: [
                {
                    title: "segment.analysis.marketingChannels.title",
                    name: "segmentTrafficChannels",
                    state: "digitalsuite_segments-analysis-marketingChannels",
                    options: {
                        isUSStatesSupported: false,
                        isVirtualSupported: false,
                    },
                    supportPredefined: true,
                },
            ],
        },
        {
            title: "analysis.buyer.journey.title",
            name: "segments",
            hidden: isHidden(swSettings.components.SegmentAnalysisUserFlow),
            subItems: [
                {
                    title: "analysis.buyer.journey.title",
                    name: "segmentBouyerJourney",
                    state: "digitalsuite_segments-buyer_journey",
                    options: {
                        isUSStatesSupported: false,
                        isVirtualSupported: false,
                    },
                    isBeta: true,
                    hidden: isHidden(swSettings.components.SegmentAnalysisUserFlow),
                },
            ],
        },
    ];

    const params = proNavigator.getParams();
    const { id, mode } = params;

    if (!id || !mode) {
        const current = proNavigator.current();
        if (current?.parent === SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID) {
            Sentry.captureException(new Error(`Invalid parameters`), {
                extra: {
                    segmentId: id,
                    mode: mode,
                },
            });
        }
        return { navList: [] };
    }

    const navItemGroups = segmentAnalysisGroup.filter((group): group is INavGroup => group !== null);

    return {
        navList: navItemGroups.map(applyNavItemPermissions),
    };
};
